module.exports = __webpack_public_path__ + "img/add-plue.2e01242e.svg";